import { CheckboxGroup, Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import { useSelector } from 'react-redux';

let ResultsSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const waterUsed = useSelector(pipe(createWorksheetSelector!('WaterUsedFlag'), valueOrDefault(false)));

  const waterTemperature = useSelector(pipe(createWorksheetSelector!('WaterTemperatureFlag'), valueOrDefault(false)));

  return (
    <>
      <ListFieldSection>
        <Field input={<TextOutput />} name="EmersonClassNumber" />
        <Field input={<TextOutput />} name="SoilDescription" />
        <Field input={<TextOutput />} name="WaterUsedResults" visible={waterUsed} />
        <Field input={<TextOutput />} name="WaterTemperatureResults" visible={waterTemperature} />
      </ListFieldSection>
      <ListFieldSection>
        <Field
          input={<CheckboxGroup />}
          label="Optional Reporting"
          options={[
            {
              name: 'WaterUsedFlag',
            },
            {
              name: 'WaterTemperatureFlag',
            },
          ]}
        />
      </ListFieldSection>
    </>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
